import e, { Component as t } from "react";
import { Ripple as r } from "../../forms/Ripple/Ripple.js";
import o from "../../../../node_modules/classnames/index.js";
import "../../../utils/DomHandler.js";
import n from "../../../utils/ObjectUtils.js";
import { Icon as i } from "../Icon/Icon.js";
function l(e, t) {
  for (var r = 0; r < t.length; r++) {
    var o = t[r];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
  }
}
function c(e) {
  return (c = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(e);
}
function a(e, t) {
  return (a = Object.setPrototypeOf || function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}
var s,
  p,
  u = function (t) {
    !function (e, t) {
      if ("function" != typeof t && null !== t) throw TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && a(e, t);
    }(m, t);
    var s,
      p,
      u,
      f = (s = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct || Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }(), function () {
        var e,
          t,
          r = c(m);
        if (s) {
          var o = c(this).constructor;
          t = Reflect.construct(r, arguments, o);
        } else t = r.apply(this, arguments);
        return (e = t) && ("object" == (e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e) || "function" == typeof e) ? e : function (e) {
          if (void 0 === e) throw ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(this);
      });
    function m() {
      return !function (e, t) {
        if (!(e instanceof t)) throw TypeError("Cannot call a class as a function");
      }(this, m), f.apply(this, arguments);
    }
    return p = [{
      key: "render",
      value: function value() {
        var t = o("paginator__first-page", {
            "paginator__page--disabled": this.props.disabled
          }),
          l = e.createElement("button", {
            className: t,
            onClick: !this.props.disabled && this.props.onClick,
            type: "button"
          }, e.createElement(r, null), e.createElement(i, {
            regular: !0,
            name: "chevron-double-left"
          }));
        if (this.props.template) {
          var c = {
            onClick: this.props.onClick,
            className: t,
            disabled: this.props.disabled,
            element: l,
            props: this.props
          };
          return n.getJSXElement(this.props.template, c);
        }
        return l;
      }
    }], l(m.prototype, p), u && l(m, u), m;
  }(t);
p = {
  disabled: !1,
  onClick: null,
  template: null
}, (s = "defaultProps") in u ? Object.defineProperty(u, s, {
  value: p,
  enumerable: !0,
  configurable: !0,
  writable: !0
}) : u[s] = p;
export { u as FirstPageLink };